<template>
    <g fill-rule="evenodd" transform="translate(-1633 -2241)">
        <path d="M1662.806 2241h-22.612c-.257 0-.501.125-.642.337l-6.424 9.2c-.186.275-.167.638.045.887l17.73 21.3c.308.368.886.368 1.194 0l17.73-21.3c.212-.256.231-.612.045-.887l-6.417-9.2c-.148-.212-.386-.337-.65-.337zm-1.24 3l4.066 6h-4.393l-3.322-6h3.65zm-12.982 0h5.826l3.321 6h-12.462l3.315-6zm-7.15 0h3.649l-3.322 6h-4.393l4.066-6zm-2.762 9h3.301l4.388 9.999-7.69-10zm6.61 0h12.436l-6.218 15.205-6.218-15.206zm11.357 9.999l4.381-10h3.302l-7.683 10z"/>
    </g>
</template>

<script>
export default {
    name: 'diamondIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 37 32');
    }
};
</script>
